export default "Escape Team opened in May 2019. \n\nThey closed in March 2121 and sold their room to FunCenter.";